import { Button, Box, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { Controller, useFormContext } from "react-hook-form";
import DisplayRetencao from "./DisplayRetencao";

export default function Step05() {

    const { getValues, handleSubmit, control, watch } = useFormContext()
    const handleBack = getValues('funcoesAux.onBack')
    const onSubmit = getValues('funcoesAux.onSubmit')
    const addRetencao = watch('step05.add_retencoes') === 'true'

    const valoresSelect = [
        { value: 'true', label: 'Sim' },
        { value: 'false', label: 'Não' }
    ]

    const handleAvancar = (data: any) => {
        const { step05 } = data
        if (step05.add_retencoes === 'true' && step05.retencoes.length === 0) {
            enqueueSnackbar("É necessário informar as retenções", { variant: "warning" })
            return
        }
        onSubmit(data)
    }

    return (
        <Grid container spacing={2}>
            <Grid size={{xs: 12}}>
                <Controller
                    name="step05.add_retencoes"
                    control={control}
                    rules={{ required: 'Campo obrigatório' }}
                    render={({ field }) => (
                        <FormControl fullWidth>
                            <FormLabel id={`adicionar-retencao`}>
                                Deseja adicionar retenções a esse título?
                            </FormLabel>

                            <RadioGroup
                                {...field}
                                row
                                aria-labelledby="retencao-radio"
                            >
                                {
                                    valoresSelect.map((opcao, index) => (
                                        <FormControlLabel
                                            key={index}
                                            value={opcao.value}
                                            control={<Radio />}
                                            label={opcao.label}
                                        />
                                    ))
                                }
                            </RadioGroup>
                        </FormControl>
                    )}
                />
            </Grid>

            {
                addRetencao && (
                    <Grid size={{xs: 12}}>
                        <DisplayRetencao />
                    </Grid>
                )
            }

            <Grid size={{xs: 12}}>
                <Box display={'flex'} gap={2}>
                    <Button
                        variant="outlined"
                        onClick={handleBack}
                    >
                        Voltar
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit(handleAvancar)}
                    >
                        Finalizar
                    </Button>
                </Box>
            </Grid>
        </Grid>
    )
}